import {Component, NgZone, OnInit} from '@angular/core';
import {AuthService} from '../../services/auth.service';
import {ActivatedRoute, Router} from '@angular/router';
import {CognitoUser} from 'amazon-cognito-identity-js';
import {HttpClient} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'aw-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  registerOTP = false;
  handler: (a: string, s: CognitoUser) => void;

  constructor(
    private httpClient: HttpClient,
    private snackBar: MatSnackBar,
    public authService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private ngZone: NgZone,
  ) {
    this.handler = this.handle.bind(this);
  }

  handle(event: string/*, a: CognitoUser*/): void {
    if (event === 'TOTPSetup') {
      this.ngZone.run(() => {
        this.registerOTP = true;
      });
    }
  }

  ngOnInit(): void {

    this.authService.onUserChange().subscribe();

  }

}
